// userSlice.js

import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  rows: [
    {
      id: 1,
      name: "Janet Adebayo",
      image: "/images/janet.jpg",
      event: "Lorem ipsum",
      ticketID: "9348fj73",
      total: "$25,000.00",
      bookingDate: "12 Aug 2022 - 12:25 am",
      status: true,
    },
    {
      id: 2,
      name: "Samuel Johnson",
      image: "/images/samuel.jpg",
      event: "Lorem ipsum",
      ticketID: "9348fj73",
      total: "$25,000.00",
      bookingDate: "12 Aug 2022 - 12:25 am",
      status: true,
    },
    {
      id: 3,
      name: "Francis Doe",
      image: "/images/francis.jpg",
      event: "Lorem ipsum",
      ticketID: "9348fj73",
      total: "$25,000.00",
      bookingDate: "12 Aug 2022 - 12:25 am",
      status: true,
    },
  ],
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    updateRows(state, action) {
      state.rows = action.payload;
    },
    toggleStatus(state, action) {
      const { id } = action.payload;
      state.rows = state.rows.map((row) =>
        row.id === id ? { ...row, status: !row.status } : row
      );
    },
    addUser(state, action) {
      const newUser = action.payload;
      state.rows.push(newUser);
    },
  },
});

export const { updateRows, toggleStatus, addUser } = userSlice.actions;

export default userSlice.reducer;
